module.exports = __webpack_public_path__ + "static/img/mobile-1.d23c4395.png";